import { render, staticRenderFns } from "./LaudoUsuario.vue?vue&type=template&id=a28cace0&"
import script from "./LaudoUsuario.vue?vue&type=script&lang=js&"
export * from "./LaudoUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports